import React from "react";
import {observable, toJS} from "mobx";
import moment from "moment/moment";
import AnaliseCriticaService from "../../../services/AnaliseCriticaService";

export default class FiltrosAnaliseCriticaStore {

    @observable maisFiltros;
    @observable filtro;
    @observable statusOptions;

    constructor(service) {
        this.service = service;

        this.maisFiltros = false;

        this.filtro = [];
        this.filtro['dataInicial'] = moment().subtract(7, 'day').format("YYYY-MM-DD");
        this.filtro['dataFinal'] = moment().add(0, 'day').format("YYYY-MM-DD");
        this.filtroAdicional = ['codigo', 'ncm', 'status'];

        this.statusOptions = [];
        this.carregarStatus();
    };

    carregarStatus = () => {
        this.service.listarStatus().then( response => {
            if(response && response.data){
                this.statusOptions = response.data;
            }
        });
    };

    alternarFiltros = () => {
        this.maisFiltros = !this.maisFiltros;
        if(this.maisFiltros === false){
            this.limparFiltroAdicional();
        }
    };

    limparFiltroAdicional = () => {
        this.filtroAdicional.map(item => {
            if(this.filtro.hasOwnProperty(item)){
                delete this.filtro[item];
            }
        });
    };

    setFiltro = (campo, valor) => {
        if(valor){
            this.filtro[campo] = valor.hasOwnProperty('target') ? valor.target.value : valor;
        } else {
            delete this.filtro[campo];
        }
    };
}


// WEBPACK FOOTER //
// ./src/modules/analise/stores/FiltrosAnaliseCriticaStore.js